import { userService } from "../services/userService";

const firstDefined = (...values) =>
  values.find((value) => value !== undefined && value !== null && value !== "");

export const getStoredUserId = () => {
  const userData = userService.getUserData();
  const payload = userService.getUserPayload() || {};

  return (
    firstDefined(
      userData.UserID,
      payload.userId,
      payload.userID,
      payload.user_id,
      payload.id,
      payload.sub,
      payload.user?.userId,
      payload.user?.userID,
      payload.user?.id,
      payload.userDetails?.userId,
      payload.userDetails?.userID,
      payload.userDetails?.id,
    ) || ""
  );
};
